import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetEarningsArgs } from "../schemas";

const getEarningsQueryKey = (args: GetEarningsArgs) =>
  ["getEarnings", args.health_care_organization_id, args.params] as const;

export const useGetEarnings = (args: GetEarningsArgs) => {
  const client = useApiClient();

  return useQuery(getEarningsQueryKey(args), () => client.getEarnings(args));
};
